<template>
  <div id="app">
    <Heads></Heads>
    <div class="pageContent">
      <router-view />
    </div>
    <Footers></Footers>

    <!-- 免费注册弹框 -->
    <div class="shade" v-show="seen"></div>
    <transition
      enter-active-class="animate__animated animate__zoomIn"
      leave-active-class="animate__animated animate__zoomOut"
    >
      <div class="register" v-show="seen">
        <div class="h">
          <p>免费试用</p>
          <img src="./assets//img/close@2x.png" @click="quxiao()" />
        </div>
        <div class="h_form">
          <el-form ref="ruleForm" :model="ruleForm" label-width="80px" :rules="rules">
            <div class="inp">
              <el-form-item prop="companyName">
                <img src="./assets//img/gongsi@2x.png" alt="" />
                <el-input v-model="ruleForm.companyName" placeholder="公司名称" style="border: 0"></el-input>
                <!-- <div class="inp_ch" >
                </div> -->
              </el-form-item>
            </div>

            <div class="inp">
              <el-form-item prop="contact">
                <div class="inp_ch">
                  <img src="./assets//img/lianxiren@2x.png" alt="" />
                  <el-input v-model="ruleForm.contact" placeholder="联系人"></el-input>
                </div>
              </el-form-item>
            </div>
            <div class="inp">
              <el-form-item prop="phone">
                <div class="inp_ch">
                  <img src="./assets//img/shouji@2x.png" alt="" />
                  <el-input v-model="ruleForm.phone" placeholder="手机号码"></el-input>
                </div>
              </el-form-item>
            </div>
            <div class="inp">
              <el-form-item prop="code">
                <div class="inp_ch">
                  <img src="./assets//img/yanzheng@2x.png" alt="" />
                  <el-input v-model="ruleForm.code" placeholder="验证码" class="yanzheng"></el-input>
                  <div class="vertical">|</div>
                  <div v-show="show" class="send" @click="getCode()">发送验证码</div>
                  <div v-show="!show" class="send_count">{{ count }}</div>
                </div>
              </el-form-item>
            </div>
          </el-form>
        </div>

        <div class="submit" @click="submit('ruleForm')">提交</div>
        <div class="register_font">
          <!-- <span> 已有账号? <button>去登录</button></span> -->
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import devPixelRatio from '@/utils/devicePixelRatio.js'
export default {
  data() {
    var checkMobile = (rule, value, callback) => {
      this.checkPhone = false
      const regMobile = /^(0|86|17951)?(1[123456789]\d{9})$/
      if (regMobile.test(value)) {
        this.checkPhone = true
        return callback()
      }
      callback(new Error('请输入合法的手机号'))
    }

    return {
      index: '',

      // 试用表单

      ruleForm: {
        companyName: '',
        contact: '',
        phone: '',
        code: ''
      },
      rules: {
        companyName: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
        contact: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            validator: checkMobile,
            trigger: 'blur'
          }
        ],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      // 读秒
      show: true,
      count: '',
      timer: null,

      carousel: '',
      seen: false,
      dbc: true, //防止重复发送
      timers: ''
    }
  },
  mounted() {
    this.seen = false
  },
  methods: {
    quxiao() {
      this.$store.commit('PageIds', false)
      // this.seen = false;
      this.show = true
      clearInterval(this.timer)
      this.timer = null
      // document.querySelector("body").setAttribute("style", " overflow: none;");
    },
    submit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios
            .post('api/hopdata-core/trial-application/add', this.ruleForm)
            .then(res => {
              if (res.data.code == 200) {
                this.$message({
                  message: '恭喜您，申请成功',
                  type: 'success'
                })

                this.show = true
                this.seen = false
                this.$store.commit('PageIds', false)
                this.ruleForm = {
                  companyName: '',
                  phone: '',
                  code: ''
                }
                clearInterval(this.timer)
              } else {
                this.$message.error(res.msg)
              }
            })
            .catch(res => {
              this.$message.error(res.response.data.msg)
            })
        }
      })
    },
    // 发送验证
    getCode() {
      if (this.ruleForm.phone !== '' && this.checkPhone) {
        const TIME_COUNT = 60
        if (!this.timer) {
          // clearInterval(this.timer)
          this.count = TIME_COUNT
          this.show = false
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--
            } else {
              this.show = true
              clearInterval(this.timer)
              this.timer = null
            }
          }, 1000)
        }

        clearTimeout(this.timers)

        this.timers = setTimeout(() => {
          this.$axios
            .post('api/hopdata-core/trial-application/sendCode', {
              phone: this.ruleForm.phone,
              type: 9
            })
            .then(res => {
              if (res.data.code == 200)
                this.$message({
                  message: '发送成功',
                  type: 'success'
                })
            })
            .catch(res => {
              this.$message.error(res.response.data.msg)
              this.dbc = true
            })
        }, 1000)
      } else {
        this.$message({
          message: '请输入合法的手机号！',
          type: 'warning'
        })
      }
    }
  },
  created() {
    new devPixelRatio().init() // 初始化页面比例
    this.$store.commit('PageIds', false)
    window.addEventListener('beforeunload', () => {
      window.sessionStorage.setItem('store', JSON.stringify(this.$store.state))
    })
  },

  computed: {
    monitor() {
      return this.$store.state.PageId
    }
  },
  watch: {
    monitor() {
      this.seen = this.$store.state.PageId
      if (this.seen) {
        this.ruleForm = {
          companyName: '',
          phone: '',
          code: ''
        }
      }
    }
  }
}
</script>
<style scoped>
::v-deep .el-form-item__error{
  font-weight: normal !important;
  padding-top: 2px;
}
</style>
<style>
body {
  overflow-x: hidden;
  margin: 0;
  padding: 0;
}
.pageContent {
  /* width:1200px;  */
  margin: 0 auto;
  /* min-height: calc(100vh - 356px); */
}

html,
body,
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* 免费试用弹窗 */
.shade {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1001;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.register {
  width: 400px;
  height: 408px;
  position: fixed;
  background: #ffffff;
  border-radius: 4px;
  margin: -204px 0 0 -200px;
  z-index: 1002;
  left: 50%;
  top: 50%;
}
.register p {
  text-align: center;
  margin-top: 32px;
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
}
.register .h {
  margin-bottom: 24px;
}
.register .h img {
  width: 24px;
  height: 24px;
  display: inline-block;
  position: absolute;
  right: 12px;
  top: 12px;
  cursor: pointer;
}
.register .h_form {
  width: 300px;
  margin: 0 auto;
}
/* input{
  border: 0;
  outline:none;
  width: 232px;
height: 20px;
font-size: 14px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #999999;
} */
.inp {
  width: 300px;
  height: 40px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #d9d9d9;

  margin-top: 16px;
}
.inp .el-input {
  border: 0;
  width: 232px;
}
.inp .el-input .el-input__inner {
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;

  border: 0;
  display: inline-block;
  padding: 0;
}
.inp_ch {
  margin-top: 10px;
  margin-left: 16px;
}
.inp img {
  width: 20px;
  height: 20px;
  vertical-align: bottom;
  margin-right: 16px;
  margin-left: 16px;
  margin-bottom: 10px;
}
.yanzheng {
  width: 103px !important;
}
.vertical {
  display: inline-block;
  width: 3px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #d9d9d9;
  line-height: 20px;
  margin-left: 49px;
}
.inp .send {
  display: inline-block;
  width: 70px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1958c4;
  line-height: 20px;
  border: 0;
  background: #ffffff;
  margin-left: 6px;
  cursor: pointer;
  text-align: center;
}
.send_count {
  display: inline-block;
  width: 70px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #606266;
  line-height: 20px;
  border: 0;
  background: #ffffff;
  margin-left: 6px;
  text-align: center;
}
.submit {
  width: 300px;
  height: 40px;
  background: #1958c4;
  border-radius: 20px;
  margin: 0 auto;
  margin-top: 32px;
  text-align: center;
  line-height: 40px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}
.register_font {
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  margin-top: 12px;
}
.register_font button {
  color: #1958c4;
  background: #ffffff;
  border: 0;
  cursor: pointer;
}
.el-form-item__content {
  margin: 0 !important;
}
.inp_ch {
  margin: 0;
}
.trial {
  padding-bottom: 0;
}
.seamless-warp {
  width: 1440px;
}
</style>
